module.exports = __webpack_public_path__ + "media/images/flag-781c37feb8f17f5cb1d1eb43bc624810.png";